/**
 * Contributing Translations Module (Spanish)
 * 
 * @module contributing
 * @language es
 */

export const contributing = {
  contributing: {
    // Hero Section
    pageTitle: "Contribuyendo a Futuros de la Juventud",
    heroSubtitle: "Una iniciativa de investigación colaborativa dedicada a comprender y avanzar el liderazgo joven globalmente",
    heroDescription: "Invitamos a instituciones, organizaciones, investigadores, miembros y socios comunitarios a contribuir datos, insights y expertise que fortalezcan nuestra plataforma.",
    
    // Why Contribute Section
    whyContributeTitle: "¿Por Qué Contribuir?",
    whyContributeSubtitle: "Tu contribución hace una diferencia real en la comprensión del liderazgo joven global",
    
    globalImpact: "Impacto Global",
    globalImpactDesc: "Tus datos llegan a formuladores de políticas, inversores, miembros JCI en todo el mundo y la comunidad global de liderazgo joven—creando impacto tangible en cómo los jóvenes líderes son desarrollados y reconocidos.",
    
    academicRecognition: "Reconocimiento Académico",
    academicRecognitionDesc: "Cita formal en informes técnicos, publicaciones científicas, presentaciones en congresos internacionales, certificados de colaboración y reconocimiento en redes sociales—válido para CV académico y portafolios profesionales.",
    
    rigorousMethodology: "Metodología Rigurosa",
    rigorousMethodologyDesc: "Todas las contribuciones siguen estándares internacionales (directrices de la ONU, mejores prácticas académicas) garantizando máxima credibilidad para tu institución y resultados.",
    
    openAccess: "Acceso Abierto",
    openAccessDesc: "Todos los hallazgos están disponibles públicamente a través de dashboards interactivos, informes técnicos (PDF), archivos de datos (CSV/Excel), bajo licencia Creative Commons—gratis para uso no comercial.",
    
    formalRecognition: "Reconocimiento Formal",
    formalRecognitionDesc: "Cita en informes técnicos y presentaciones, mención en congresos y eventos internacionales, certificado digital de colaboración, reconocimiento en los canales de redes sociales de JCI, válido para credenciales profesionales.",
    
    // Who Can Contribute Section
    whoCanContributeTitle: "¿Quién Puede Contribuir?",
    whoCanContributeSubtitle: "Las perspectivas diversas fortalecen nuestra plataforma de investigación",
    
    nationalOrgs: "Organizaciones Nacionales JCI",
    nationalOrgsDesc: "Comparte datos estratégicos sobre desarrollo de liderazgo, compromiso de miembros, impacto de programas e iniciativas regionales.",
    nationalOrgsDetails: "Estadísticas y demografía de miembros nacionales, resultados de programas y proyectos alineados con el Plan Estratégico JCI 2023-2027, tendencias e insights de liderazgo regional, resultados de alianzas y colaboraciones, métricas de capacitación y desarrollo, datos de asistencia a eventos, iniciativas estratégicas e innovaciones.",
    nationalOrgsWhy: "Ayuda al Observatorio a reflejar la verdadera diversidad e impacto de JCI en todas las regiones y países.",
    
    committees: "Comités y Consejos JCI",
    committeesDesc: "Los comités especializados contribuyen expertise en dimensiones específicas de desarrollo de liderazgo.",
    committeesDetails: "Consejos de Desarrollo (Estratégico, Operativo, Educativo, Impacto), datos y métricas específicas de consejos, mejores prácticas y metodologías, resultados de desarrollo de miembros, resultados de capacitación y certificación, indicadores de desempeño regional.",
    committeesWhy: "Permite que el Observatorio presente perspectivas especializadas sobre cómo JCI desarrolla líderes en todas las dimensiones estratégicas.",
    
    individualMembers: "Miembros Individuales JCI",
    individualMembersDesc: "Cada miembro tiene insights y experiencias valiosas para compartir.",
    individualMembersDetails: "Historias personales de desarrollo de liderazgo, retroalimentación y resultados de participación en programas, experiencias de desarrollo de habilidades y capacitación, insights de mentoría y networking, ejemplos de avance profesional, proyectos de impacto comunitario, correcciones y actualizaciones de calidad de datos, sugerencias metodológicas y retroalimentación.",
    individualMembersWhy: "Las voces de los miembros aseguran que el Observatorio refleje viajes reales de liderazgo y experiencias vividas dentro de JCI.",
    
    researchPartners: "Socios de Investigación e Instituciones Académicas",
    researchPartnersDesc: "Universidades, centros de investigación y grupos académicos contribuyen investigación y análisis original.",
    researchPartnersDetails: "Artículos de investigación académica y estudios, estudios longitudinales sobre desarrollo de miembros JCI, análisis comparativo con otras organizaciones de liderazgo, revisiones y validaciones metodológicas, proyectos de investigación estudiantil, mapeo y análisis institucional, estudios de alineación curricular, conjuntos de datos y hallazgos publicados.",
    researchPartnersWhy: "Las alianzas académicas validan al Observatorio como una plataforma de investigación creíble alineada con estándares internacionales.",
    
    educationalInstitutions: "Instituciones Educativas y Centros de Capacitación",
    educationalInstitutionsDesc: "Escuelas, universidades, centros vocacionales y organizaciones de capacitación contribuyen datos educativos.",
    educationalInstitutionsDetails: "Mapeo de currículo de liderazgo, inscripción y resultados de estudiantes miembros JCI, resultados de programas de capacitación, métricas de desarrollo de habilidades, datos de empleo de graduados, resultados de programas de alianza, alineación de cursos con el marco JCI, datos de certificación y credenciales.",
    educationalInstitutionsWhy: "Los datos educativos revelan cómo el desarrollo de liderazgo JCI se traduce en avance académico y profesional.",
    
    governmentNgos: "Gobierno, ONGs y Socios Institucionales",
    governmentNgosDesc: "Agencias gubernamentales, organizaciones internacionales y socios de la sociedad civil contribuyen datos estratégicos.",
    governmentNgosDetails: "Alineación de políticas públicas con iniciativas JCI, resultados de alianzas gubernamentales, datos de colaboración con organizaciones internacionales, efectividad de alianzas con ONGs, métricas de impacto comunitario, datos de sostenibilidad y responsabilidad social, reconocimiento y avales institucionales, alineación regulatoria y de marcos.",
    governmentNgosWhy: "Las alianzas institucionales demuestran la credibilidad de JCI y alineación con agendas globales de desarrollo.",
    
    // How to Contribute Section
    howToContributeTitle: "Cómo Contribuir",
    howToContributeSubtitle: "Envía tu contribución por correo electrónico con la información requerida",
    
    contributionFormTitle: "Formulario de Contribución",
    contributionFormDesc: "Envía tu contribución usando nuestro formulario. Todos los campos son obligatorios.",
    sendTo: "La información se enviará a:",
    
    yourInformation: "Tu Información",
    fullName: "Nombre Completo",
    fullNameDesc: "Tu nombre completo",
    affiliatedOrg: "Organización Afiliada",
    affiliatedOrgDesc: "Organización Nacional, Comité, Institución, Empresa, etc.",
    emailAddress: "Correo Electrónico",
    emailAddressDesc: "Donde te contactaremos",
    yourRole: "Tu Cargo",
    yourRoleDesc: "Posición/función en tu organización",
    
    contributionDetails: "Detalles de la Contribución",
    contributionType: "Tipo de Contribución",
    contributionTypeDesc: "Selecciona categoría: Datos de Investigación, Resultados de Programa, Insights de Miembros, Alianza Institucional, Resultados de Capacitación, Análisis Estratégico, Mejora de Calidad, Otro",
    contributionDescription: "Descripción de la Contribución",
    contributionDescriptionDesc: "Describe brevemente lo que ofreces y por qué es relevante (mínimo 20 caracteres)",
    dataFormat: "Formato de Datos",
    dataFormatDesc: "¿Cómo están disponibles los datos? (Excel, PDF, Artículo científico, Link, Base de datos, Informe, Otro)",
    dataScope: "Alcance de los Datos",
    dataScopeDesc: "Alcance geográfico y período cubierto",
    verificationStatus: "Estado de Verificación",
    verificationStatusDesc: "¿Estos datos están verificados/auditables? Sí / No",
    
    authorization: "Autorización y Compromiso",
    citationAuth: "Autorizo el uso de los datos proporcionados en el Observatorio JCI, con atribución formal de fuente en todos los materiales publicados",
    dataOwnership: "Confirmo que mi organización posee o tiene permiso para compartir estos datos",
    accuracy: "Certifico que los datos proporcionados son precisos y representan la mejor información disponible",
    required: "Obligatorio",
    
    // Contribution Process Section
    processTitle: "Proceso de Contribución",
    processSubtitle: "De la presentación a la publicación en 2-4 semanas",
    
    step1: "Contacto y Presentación",
    step1Desc: "Envía tu propuesta por correo electrónico con el formulario completado",
    step2: "Revisión Inicial",
    step2Desc: "Nuestro equipo evalúa relevancia, calidad y alineación con valores y metodología JCI",
    step3: "Verificación de Datos",
    step3Desc: "Verificamos fuentes de datos, metodologías y precisión antes de la integración",
    step4: "Integración",
    step4Desc: "Los datos e insights se incorporan a la plataforma del Observatorio",
    step5: "Reconocimiento Formal",
    step5Desc: "Tu contribución recibe cita formal, certificado y reconocimiento público",
    
    timeline: "Plazo: 2-4 semanas desde la presentación hasta la publicación",
    
    // Our Commitments Section
    commitmentsTitle: "Nuestros Compromisos",
    commitmentsSubtitle: "Lo que prometemos a cada contribuidor",
    
    transparencyProtocol: "Protocolo de Transparencia",
    transparencyProtocolDesc: "Mantenemos total transparencia en todas las contribuciones: todas las fuentes citadas con créditos completos, nombres de organizaciones y contribuidores claramente identificados, título del trabajo/conjunto de datos y fecha de publicación documentados, enlace completo y DOI cuando esté disponible, referencias bibliográficas completas, metodología y fórmulas de cálculo explicadas, limitaciones de datos claramente declaradas. Cada contribución es rastreable y auditable.",
    
    openMethodology: "Metodología Abierta",
    openMethodologyDesc: "El Observatorio opera con total transparencia metodológica: todos los marcos e indicadores documentados, metodologías de cálculo completamente explicadas, disponible para auditoría académica pública, informes técnicos con detalles completos, hojas de cálculo con todas las fórmulas, FAQ abordando preguntas metodológicas, revisiones y actualizaciones metodológicas regulares. Puedes verificar todo lo que publicamos.",
    
    formalRecognitionCommitment: "Reconocimiento Formal",
    formalRecognitionCommitmentDesc: "Los contribuidores reciben reconocimiento integral: cita en todos los informes técnicos y publicaciones, mención en presentaciones en congresos internacionales JCI, certificado digital de colaboración (descargable), reconocimiento en los canales de redes sociales de JCI, destacado en la sección \"Contribuidores\" del Observatorio, invitación a coautoría de estudios especiales, acceso prioritario a nuevos conjuntos de datos del Observatorio. Tu contribución construye la credibilidad de tu institución.",
    
    publicAccess: "Acceso Público",
    publicAccessDesc: "Todos los datos e insights del Observatorio están disponibles gratuitamente: dashboard online interactivo, informes técnicos en formato PDF, archivos de datos en formato CSV/Excel, Licencia Creative Commons BY-NC-SA 4.0, gratis para uso académico no comercial, licenciamiento comercial disponible bajo solicitud, acceso API para socios de investigación registrados. Tus insights llegan a una audiencia global.",
    
    dataQualityStandards: "Estándares de Calidad de Datos",
    dataQualityStandardsDesc: "Mantenemos prácticas rigurosas de calidad de datos: todos los datos deben ser verificados y auditables, ningún dato sintético o estimado sin notación clara, las fuentes deben estar públicamente documentadas, la metodología debe ser replicable, precisión de datos verificada antes de la publicación, auditorías y revisiones de calidad regulares, procedimientos de corrección para errores. La excelencia es innegociable.",
    
    // Contribution Types Section
    contributionTypesTitle: "Tipos de Contribución y Ejemplos",
    contributionTypesSubtitle: "Diferentes formas de contribuir al Observatorio",
    
    researchData: "Datos de Investigación",
    researchDataExamples: "Artículos de investigación académica sobre liderazgo juvenil, estudios longitudinales sobre desarrollo de miembros, análisis comparativos con organizaciones pares, resultados de encuestas y análisis estadísticos",
    
    programResults: "Resultados de Programas",
    programResultsExamples: "Métricas de resultados de programas JCI, evaluaciones de impacto de proyectos, datos de finalización de capacitación y certificación, estadísticas de compromiso y retención de miembros",
    
    memberInsights: "Insights de Miembros",
    memberInsightsExamples: "Datos demográficos de miembros, ejemplos de avance profesional, historias de desarrollo de habilidades de liderazgo, resultados de programas de mentoría",
    
    institutionalPartnerships: "Alianzas Institucionales",
    institutionalPartnershipsExamples: "Datos de efectividad de alianzas, resultados de colaboraciones, resultados de programas conjuntos, avales institucionales",
    
    trainingOutcomes: "Resultados de Capacitación",
    trainingOutcomesExamples: "Métricas de programas de capacitación, datos de certificación, evaluaciones de desarrollo de habilidades, análisis de alineación educativa",
    
    strategicAnalysis: "Análisis Estratégico",
    strategicAnalysisExamples: "Tendencias e insights regionales, análisis sectoriales específicos, documentación de mejores prácticas, estudios de caso de innovación",
    
    qualityImprovements: "Mejoras de Calidad",
    qualityImprovementsExamples: "Correcciones y actualizaciones de datos, sugerencias metodológicas, identificación de información faltante, recomendaciones de mejora de procesos",
    
    // Data Requirements Section
    dataRequirementsTitle: "Requisitos de Datos",
    dataRequirementsSubtitle: "Para que las contribuciones sean aceptadas, asegúrate de:",
    
    mandatoryElements: "Elementos Obligatorios",
    mandatoryList: "Identificación clara de la fuente de datos, período cubierto (rango de fechas), alcance geográfico (regional, nacional, global), metodología de recolección de datos, tamaño de muestra (si aplica), declaración de verificación, declaración de permiso para compartir",
    
    recommendedElements: "Elementos Recomendados",
    recommendedList: "Persona de contacto para preguntas, documentación de soporte, estudios o referencias relacionados, limitaciones o advertencias, uso/interpretación sugeridos, conjuntos de datos relacionados para referencia cruzada, frecuencia de actualización (si es recurrente)",
    
    // FAQ Section
    faqTitle: "Preguntas Frecuentes",
    faqSubtitle: "Preguntas comunes sobre contribuir al Observatorio",
    
    faq1Q: "¿Cuánto tiempo toma el proceso de contribución?",
    faq1A: "Típicamente 2-4 semanas desde la presentación hasta la publicación, dependiendo de la complejidad de los datos y los pasos de verificación requeridos.",
    
    faq2Q: "¿Mi organización será acreditada?",
    faq2A: "Sí, absolutamente. Todas las contribuciones reciben cita formal en cada publicación donde aparecen.",
    
    faq3Q: "¿Podemos contribuir datos confidenciales?",
    faq3A: "Generalmente no—el Observatorio requiere datos públicos y verificables. Sin embargo, datos agregados o anonimizados pueden ser posibles. Contáctanos para discutir situaciones específicas.",
    
    faq4Q: "¿Necesitamos contribuir datos para usar el Observatorio?",
    faq4A: "No. El Observatorio es gratuito y abierto para todos. Las contribuciones son voluntarias y apreciadas, pero no obligatorias.",
    
    faq5Q: "¿Qué pasa si encontramos un error en nuestros datos?",
    faq5A: "Tenemos un procedimiento de corrección. Contáctanos inmediatamente y actualizaremos los datos y publicaremos un aviso de erratum.",
    
    faq6Q: "¿Las contribuciones pueden actualizarse?",
    faq6A: "Sí. Las actualizaciones anuales son incentivadas. Envía datos actualizados en cualquier momento con un historial de versiones claro.",
    
    faq7Q: "¿Hay algún costo para contribuir?",
    faq7A: "No. Las contribuciones son voluntarias. Valoramos tu expertise e insights.",
    
    // Team & Contact Section
    teamTitle: "Nuestro Equipo",
    teamSubtitle: "Contáctanos para iniciar tu viaje de contribución",
    
    observatoryTeam: "Equipo del Observatorio JCI",
    dashcityTeam: "Equipo Dashcity",
    email: "Email",
    website: "Sitio Web",
    contactForm: "Formulario de Contacto",
    
    developmentCouncils: "Coordinación de Consejos de Desarrollo",
    strategicCouncil: "Consejo de Desarrollo Estratégico",
    operationalCouncil: "Consejo de Desarrollo Operativo",
    educationalCouncil: "Consejo de Desarrollo Educativo",
    impactCouncil: "Consejo de Desarrollo de Impacto",
    
    // Our Commitments to You Section
    partnershipTitle: "Nuestros Compromisos Contigo",
    partnershipSubtitle: "Cuando contribuyes al Observatorio JCI, te asocias con:",
    
    commitment1: "Una organización global de liderazgo juvenil con 100+ años de historia y presencia en 120 países",
    commitment2: "Una institución orientada por datos alineada con los Objetivos de Desarrollo Sostenible de la ONU y mejores prácticas internacionales",
    commitment3: "Una plataforma de investigación creíble construida sobre metodología rigurosa y procesos transparentes",
    commitment4: "Una comunidad inclusiva que valora perspectivas y voces diversas",
    commitment5: "Un movimiento creciente transformando cómo los jóvenes líderes son desarrollados y reconocidos",
    
    // Why Your Data Matters Section
    whyDataMattersTitle: "Por Qué Tus Datos Importan",
    whyDataMattersSubtitle: "El Observatorio JCI existe para responder preguntas críticas:",
    
    question1: "¿Cómo se desarrollan los jóvenes líderes globalmente?",
    question2: "¿Qué habilidades importan más para los futuros líderes?",
    question3: "¿Cómo transforma JCI las vidas de los miembros?",
    question4: "¿Qué crea impacto de liderazgo sostenible?",
    question5: "¿Cómo la mentoría, capacitación y comunidad moldean líderes?",
    
    dataMattersConclusion: "Tu contribución ayuda a responder estas preguntas con datos reales, experiencias reales e impacto real. Juntos, estamos construyendo la plataforma autoritativa para entender el desarrollo del liderazgo juvenil.",
    
    // CTA Section
    ctaTitle: "¿Listo para Contribuir?",
    ctaSubtitle: "Tres Pasos Sencillos",
    
    ctaStep1: "Completa el formulario con los detalles de tu contribución",
    ctaStep2: "Envía a tmariano@jci.cc con cualquier archivo de soporte",
    ctaStep3: "Espera confirmación - nuestro equipo te contactará en 5 días hábiles",
    
    questionsTitle: "¿Preguntas Antes de Empezar?",
    questionsContact: "Envíanos un correo a: observatory@jci.cc",
    questionsAlternative: "O contacta a tu representante regional del Consejo de Desarrollo a través de tu Organización Nacional.",
    
    startContributing: "Empezar a Contribuir",
    contactUs: "Contáctanos",
    
    // Checklist
    checklistTitle: "Lista de Verificación de Contribución",
    checklistSubtitle: "Antes de enviar, verifica que tienes:",
    
    checkItem1: "Información completa del contribuidor",
    checkItem2: "Tipo de contribución claramente seleccionado",
    checkItem3: "Documentación de la fuente de datos",
    checkItem4: "Período y alcance geográfico definidos",
    checkItem5: "Declaración de verificación/auditoría",
    checkItem6: "Autorización para compartir",
    checkItem7: "Archivos de soporte listos",
    checkItem8: "Información de contacto para seguimiento",
    
    // Footer info
    lastUpdated: "Última Actualización: Diciembre 2025",
    availableLanguages: "Disponible en Inglés, Portugués, Español, Francés y Japonés",
    joinCommunity: "¡Únete a la comunidad de contribuidores construyendo el futuro de la investigación en liderazgo juvenil!",
  },
} as const;
